/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/atom.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const atomPage: ICoinPageData = {
  title: 'coin_96',
  description: 'coin_97',
  // description: 'coin_98',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Cosmos (ATOM)' }) }} />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_99',
        answer: 'coin_100',
      },
      {
        title: 'coin_101',
        answer: 'coin_102',
      },
      {
        title: 'coin_103',
        answer: 'coin_104',
      },
      {
        title: 'coin_105',
        answer: 'coin_106',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Cosmos'),
    text: [],
    paragraphs: [
      {
        title: 'coin_107',
        text: ['coin_109'],
      },
      {
        title: 'coin_108',
        text: ['coin_110'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-atom-crypto-and-its-benefits-profit/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/06/Gain-profit-2.jpg',
        imageAlt: 'Hold Atom & Gain profit',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
